



















import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import HeaderComponent from './../components/HeaderComponent.vue'
import FooterComponent from './../components/FooterComponent.vue'
import NavigationComponent from './../components/NavigationComponent.vue'
// import popUpModal from './../components/PopUpModalComponent.vue'
import SideNavigationComponent from './../components/SideNavigationComponent.vue'

@Component({
    // All component options are allowed in here
    name: 'main-layout',
    components: {
        'ldw-header': HeaderComponent,
        'ldw-footer': FooterComponent,
        'ldw-nav': NavigationComponent,
        'ldw-side-nav': SideNavigationComponent
        // popUpModal
    }
})

export default class MainLayout extends Vue {
    // data
    private isHintVisible: boolean = true

    private mounted() {
        if (sessionStorage.getItem('acceptedHint')) {
            this.isHintVisible = false
        }
    }
    // methods
    private closeModal() {
        this.isHintVisible = false
        sessionStorage.setItem('acceptedHint', 'true')
    }
}
